import styled from '@emotion/styled';
import StyledCallToActionLinkAtom from '@atoms/link-atoms/call-to-action-link-atom';
import vars from '@variables';
import { defineResponsiveGridColumns } from '@utils/utils';
import { H2Atom, HighlightAtom, PAtom } from '@atoms/text-atoms/text-atoms';
import { sectionTitleBorder } from '../../mixins';

export const CircularExamplesWrapper = styled.div<{ colour: string }>`
  /* TODO: Specific styling if only one example provided? */
  width: 100%;
  margin-top: ${vars.spacingXxl};
  margin-bottom: ${vars.spacingXxl};
  .component-grid-structure {
    display: grid;
    column-gap: ${vars.mobileColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(4)};
    @media screen and (min-width: ${vars.breakPointTablet}) {
      column-gap: ${vars.standardColumnPercentageGap};
      grid-template-columns: ${defineResponsiveGridColumns(12)};
    }

    .circular-examples-tabs-container {
      display: flex;
      grid-column: col1-start / col4-end;
      @media screen and (min-width: ${vars.breakPointTablet}) {
        grid-column: col1-start / col12-end;
      }
      position: relative;
    }
  }

  ${H2Atom} {
    font-weight: ${vars.fontWeightBold};
    grid-column: col1-start / col7-end;
    ${({ colour }) => sectionTitleBorder(colour)};
    margin-bottom: ${vars.spacingM};
  }
  .block-subtitle {
    grid-column: col1-start / col7-end;
    margin-bottom: ${vars.spacingM};
  }

  ${HighlightAtom} {
    ${vars.fontSize7}
    line-height: 1.33;
  }

  .tabs-separator {
    display: block;
    grid-column: col1-start / col4-end;
    border-top: 1px solid ${vars.coreDarkGrey};
    margin-bottom: 3rem;
    margin-top: -1px;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col1-start / col12-end;
    }
  }

  .left-column {
    grid-column: col1-start / col4-end;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col1-start / col5-end;
    }

    ${PAtom} {
      line-height: 1.6;
    }

    ${StyledCallToActionLinkAtom} {
      margin-top: ${vars.spacingM};
      padding: 1.5rem 3rem;
      margin-top: ${vars.spacingM};
    }
  }

  .right-column {
    display: none;
    @media screen and (min-width: ${vars.breakPointTablet}) {
      display: block;
      grid-column: col7-start / col12-end;
    }

    .image-wrapper {
      .gatsby-image-pos,
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
    .logo-wrapper {
      max-height: 13rem;
      border: 1px dashed ${vars.dunedainGrey};
      border-left: 3px solid ${({ colour }) => colour};
      margin-bottom: 2rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        transform: scale(0.8);
        max-height: 13rem;
      }
    }
  }
`;
